import M3BusinessesSection from './M3BusinessesSection';

export default M3BusinessesSection;
